import { render, staticRenderFns } from "./ExpansionSectionBlock.vue?vue&type=template&id=1cc15302&scoped=true"
import script from "./ExpansionSectionBlock.vue?vue&type=script&lang=js"
export * from "./ExpansionSectionBlock.vue?vue&type=script&lang=js"
import style0 from "./ExpansionSectionBlock.vue?vue&type=style&index=0&id=1cc15302&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc15302",
  null
  
)

export default component.exports